import angular from 'angular';
import app from '@/app';

function filter() {
	return json => angular.toJson(json, true);
}

app.filter('prettyJson', filter);
